module.exports = __webpack_public_path__ + "static/media/4n_website_logo_sup_hkiota.1c8e51dd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/home/partners_logos/4n_website_logo_sup_hkiota.jpg
// module id = 67
// module chunks = 0